// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__mtfsG","title":"FrontImage_title__3kwN3"};